export default "__VITE_ASSET__Cq5BYz9X__"